import type { SSOLoginRequestBody } from "~/backend/generated/FederatedAuth/model/sSOLoginRequestBody";
import type { IdpConfig } from "~/modules/auth/Authenticator/Authenticator";
import { sanitizeSSOParams } from "./sanitizeSSOParams";

export function getSSOLoginRequestBody(config: IdpConfig): SSOLoginRequestBody {
    return {
        products: ["flex"],
        resource: sanitizeSSOParams(config.redirectUrl)
    };
}
